// extracted by mini-css-extract-plugin
export default {"desktopMenu":"DesktopMenu_desktopMenu__pki8c"};